export default __webpack_public_path__ + "static/media/manufactoring-equipment.10cd2167.PNG";